import { render, staticRenderFns } from "./typeCard.vue?vue&type=template&id=f386344a"
import script from "./typeCard.vue?vue&type=script&lang=js"
export * from "./typeCard.vue?vue&type=script&lang=js"
import style0 from "./typeCard.vue?vue&type=style&index=0&id=f386344a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports